import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Stage2 } from 'src/app/models/department-reports.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-stage2-report',
  templateUrl: './stage2-report.component.html',
  styleUrls: ['./stage2-report.component.scss']
})
export class Stage2ReportComponent implements OnInit {

  stage2: any[];
  totalApp:number;
  totalReceivedCoverageArea:number;
  totalApproveApp:number;
  totalApprovedCoverageArea:number;
  totalAppIncomplete:number;
  totalAppPending:number;
  totalAppRejected:number;
  totalIntimationStage1:number;
  pendingAtJe:number;
  pendingAtXen:number;
  pendingAtDmicada:number;
  pendingAtAdmin:number;
  phyDone:number;
  grandTotalApp:number;
  grandTotalReceivedCoverageArea:number;
  grandTotalApproveApp:number;
  grandTotalApprovedCoverageArea:number;
  grandTotalAppIncomplete:number;
  grandTotalAppPending:number;
  grandTotalAppRejected:number;
  grandTotalIntimationStage1:number;
  grandPendingAtJe:number;
  grandPendingAtXen:number;
  grandPendingAtDmicada:number;
  grandPendingAtAdmin:number;
  grandPhyDone:number;
  arrayIndex:number;
  tempStage2: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: Stage2[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  drilldownDetails:any;
  displayMaximizable_all:boolean;
  displayMaximizable_verified:boolean;
  displayMaximizable_incomplete:boolean;
  displayMaximizable_rejected:boolean;
  displayMaximizable_pending:boolean;
  value:any;
  displayMaximizable_intimation:boolean;
  displayMaximizable_je:boolean;
  displayMaximizable_xen:boolean;
  displayMaximizable_dmicada:boolean;
  displayMaximizable_admin:boolean;
  displayMaximizable_phy:boolean;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  public subscriptions: any = [];
  public loading: boolean = false;

  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
        
      this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Stage2_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Stage2_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
   // this.loader.start();
   this.loading = true;
   let sub=this.reportsService.getStage2_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.activityRecordService.activityRecord(this.userID, 'Stage-2 Report', '', new Date(), 'Success');
           // this.loader.close();
           this.loading = false;
            if (data?.length > 0) {
              this.stage2 = data;
              this.appVerificationModel = data;
              this.tempStage2=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.stage2 = [];
              this.appVerificationModel =[] ;
              this.tempStage2=[];
              this.arrayIndex=0;
              this.calculateGrandTotal()
            }
          },
          error: (err) => {
           // this.loader.close();
           this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Stage-2 Report', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "district" : d.district,
          "Total App Recieved" : d.Total_App_Recieved,
          "Recieved Coverage Area": d.recieved_Coverage_Area,
          "Total Approved Application": d.total_Approved_Application,
          "Approved Coverage Area": d.approved_Coverage_Area,
          "Total App Incomplete": d.total_App_Incomplete,
          "Total App Pending": d.total_App_Pending,
          "Total App Rejected": d.total_App_Rejected,
          "Total Intimation Stage2": d.total_Intimation_Stage2,
          "Pending At JE": d.pending_At_JE,
          "Pending At XEN": d.pending_At_XEN,
          "Pending At DMICADA": d.pending_At_DMICADA,
          "Pending At Admin": d.pending_At_Admin,
          "PHY Done": d.PHY_Done,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'district', header: 'district'},
      {field: 'Total_App_Recieved', header: 'Total App Recieved'},
      { field: 'recieved_Coverage_Area', header: 'Recieved Coverage Area' },
      { field: 'total_Approved_Application', header: 'Total Approved Application' },
      {field: 'approved_Coverage_Area', header: 'Approved Coverage Area'},
      {field: 'total_App_Incomplete', header: 'Total App Incomplete'},
      {field: 'total_App_Pending', header: 'Total App Pending'},
      {field: 'total_App_Rejected', header: 'Total App Rejected'},
      {field: 'total_Intimation_Stage2', header: 'Total Intimation Stage2'},
      {field: 'pending_At_JE', header: 'Pending At JE'},
      {field: 'pending_At_XEN', header: 'Pending At XEN'},
      {field: 'pending_At_DMICADA', header: 'Pending At DMICADA'},
      {field: 'pending_At_Admin', header: 'Pending At Admin'},
      {field: 'PHY_Done', header: 'PHY Done'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempStage2=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.totalApp=0;
        this.totalReceivedCoverageArea=0;
        this.totalApproveApp=0;
        this.totalApprovedCoverageArea=0;
        this.totalAppIncomplete=0;
        this.totalAppPending=0;
        this.totalAppRejected=0;
        this.totalIntimationStage1=0;
        this.pendingAtJe=0;
        this.pendingAtXen=0;
        this.pendingAtDmicada=0;
        this.pendingAtAdmin=0;
        this.phyDone=0;
        
          for(let i=this.arrayIndex ;this.tempStage2.length>10?i<this.arrayIndex+10:i<this.tempStage2.length;i++) {
            this.totalApp +=this.tempStage2[i].Total_App_Recieved;
            this.totalReceivedCoverageArea +=this.tempStage2[i].recieved_Coverage_Area;
            this.totalApproveApp +=this.tempStage2[i].total_Approved_Application;
            this.totalApprovedCoverageArea += this.tempStage2[i].approved_Coverage_Area;
            this.totalAppIncomplete += this.tempStage2[i].total_App_Incomplete;
            this.totalAppPending += this.tempStage2[i].total_App_Pending;
            this.totalAppRejected += this.tempStage2[i].total_App_Rejected;
            this.totalIntimationStage1 +=this.tempStage2[i].total_Intimation_Stage2;
            this.pendingAtJe +=this.tempStage2[i].pending_At_JE;
            this.pendingAtXen +=this.tempStage2[i].pending_At_XEN;
            this.pendingAtDmicada +=this.tempStage2[i].pending_At_DMICADA;
            this.pendingAtAdmin +=this.tempStage2[i].pending_At_Admin;
            this.phyDone +=this.tempStage2[i].PHY_Done;
  
          }

        
              
    }
    calculateGrandTotal(){
      this.grandTotalApp=0;
      this.grandTotalReceivedCoverageArea=0;
      this.grandTotalApproveApp=0;
      this.grandTotalApprovedCoverageArea=0;
      this.grandTotalAppIncomplete=0;
      this.grandTotalAppPending=0;
      this.grandTotalAppRejected=0;
      this.grandTotalIntimationStage1=0;
      this.grandPendingAtJe=0;
      this.grandPendingAtXen=0;
      this.grandPendingAtDmicada=0;
      this.grandPendingAtAdmin=0;
      this.grandPhyDone=0;
      for(let stage2Data of this.tempStage2) {
        this.grandTotalApp += stage2Data.Total_App_Recieved;
        this.grandTotalReceivedCoverageArea += stage2Data.recieved_Coverage_Area;
        this.grandTotalApproveApp += stage2Data.total_Approved_Application;
        this.grandTotalApprovedCoverageArea += stage2Data.approved_Coverage_Area;
        this.grandTotalAppIncomplete += stage2Data.total_App_Incomplete;
        this.grandTotalAppPending += stage2Data.total_App_Pending;
        this.grandTotalAppRejected += stage2Data.total_App_Rejected;
        this.grandTotalIntimationStage1 += stage2Data.total_Intimation_Stage2;
        this.grandPendingAtJe += stage2Data.pending_At_JE;
        this.grandPendingAtXen += stage2Data.pending_At_XEN;
        this.grandPendingAtDmicada += stage2Data.pending_At_DMICADA;
        this.grandPendingAtAdmin += stage2Data.pending_At_Admin;
        this.grandPhyDone += stage2Data.PHY_Done;
    }
    }
    showMaximizableDialog(district:any,status:any) {
      
      if(status=='All'){
        this.displayMaximizable_all=true
      }
      if(status=='Approved'){
        this.displayMaximizable_verified=true
      }
      if(status=='Incomplete'){
        this.displayMaximizable_incomplete=true
      }
      if(status=='Rejected'){
        this.displayMaximizable_rejected=true
      }
      if(status=='Pending'){
        this.displayMaximizable_pending=true
      }
      this.value=district
      this.drilldownDetails={
        district:district,
        status:status,
      }
  }

  showMaximizableDialog_pending(district:any,actionType:any) {
      
    if(actionType=='Stage2Intimation'){
      this.displayMaximizable_intimation=true
    }
    if(actionType=='PendingJEStage2'){
      this.displayMaximizable_je=true
    }
    if(actionType=='PendingXENStage2'){
      this.displayMaximizable_xen=true
    }
    if(actionType=='PendingDMICADAStage2'){
      this.displayMaximizable_dmicada=true
    }
    if(actionType=='PendingAdminStage2'){
      this.displayMaximizable_admin=true
    }
    if(actionType=='PVtage2'){
      this.displayMaximizable_phy=true
    }
    this.value=district
    this.drilldownDetails={
      district:district,
      actionType:actionType,
      program:'Stage2'
    }
}

}
